const REF_ID_STORAGE_KEY = "shaku_ref_id";

export const initializeRefId = (): void => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const refIdFromUrl = urlParams.get("ref");

    if (refIdFromUrl) {
      localStorage.setItem(REF_ID_STORAGE_KEY, refIdFromUrl);
    }
  } catch (error) {
    console.error("Error initializing ref_id:", error);
  }
};

export const getStoredRefId = (): string | undefined => {
  try {
    const refId = localStorage.getItem(REF_ID_STORAGE_KEY);
    return refId || undefined;
  } catch (error) {
    console.error("Error retrieving stored ref_id:", error);
    return undefined;
  }
};

export const clearStoredRefId = (): void => {
  try {
    localStorage.removeItem(REF_ID_STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing stored ref_id:", error);
  }
};

export const addRefIdToPayload = <T extends Record<string, any>>(payload: T): T & { ref_id?: string } => {
  const refId = getStoredRefId();

  if (refId) {
    return {
      ...payload,
      ref_id: refId,
    };
  }

  return payload;
};
